import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations';
import RootState from '@vue-storefront/core/types/RootState';
import TransportState from '../types/TransportState';

export const module: Module<TransportState, RootState> = {
  namespaced: true,
  state: {
    transport: []
  },
  actions,
  getters,
  mutations
}
